/**
 * This file fetches the ID from the received data in `postMessage` event.
 */

import { PREFIX } from './constants';

/**
 * This function retrieves and returns the ID from the data.
 *
 * @param {object} data The event data received on postMessage
 * @return {number} Returns the ID.
 */
function getID( data ) {
	let id;

	if ( data && data.id && ~data.id.indexOf( PREFIX ) ) {
		id = data.id;
	}

	return id;
}

export default getID;
